import { Divider, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { amplitude, getJobById, getSubmissionJobsByCandidateId, IJob } from 'wisestep-api';
import { WsTypography, WsTypoColors, WsColors, WsTypoVariants } from 'wisestep-base';

import conversationWidgetStore from '../../../../features/conversationWidget/store/conversationWidgetStore';
import NoSubmissionSVG from '../../../../images/NoSubmission.svg';
import { useCandidateViewData } from '../../utils/CandidateViewContext';
import JobList from '../childComponets/jobList';
import Resizable from '../childComponets/resizable/Resizable';
import NoPreview from '../documents/components/NoPreview';

import SubmissionLayout from './submissionDataLayout/SubmissionLayout';

const Submissions = () => {
  const { candidateViewData } = useCandidateViewData();
  const [loading, setLoading] = useState<boolean>(false);
  const [params] = useSearchParams();
  const updateSelectedJob = conversationWidgetStore((state) => state.updateSelectedJob);
  const [jobs, setJobs] = useState<IJob[]>([]);
  const [selectedJob, setSelectedJob] = useState<IJob>();
  const onSelect = async (jobId?: string) => {
    const currentJob = jobs.find((job) => job.id === jobId);
    setSelectedJob(currentJob);
    amplitude('CandidateView_Submission_Select', {
      clickedOn: 'Select Submission',
      pageName: 'candidate-layout',
      pageUrl: window.location.href,
    });
  };
  useEffect(() => {
    const jobId = params.get('jobId');
    const fetchJobById = async () => {
      try {
        if (jobId) {
          const response = await getJobById(jobId);
          response?.data && updateSelectedJob(response.data);
        }
      } catch (error) {
        console.error('Error fetching job:', error);
      }
    };
    fetchJobById();
    (async () => {
      try {
        setLoading(true);
        const res = await getSubmissionJobsByCandidateId(candidateViewData?.id ?? '');
        const uniqueSubmissions = res.data;
        const job = jobId
          ? uniqueSubmissions?.find((item) => item.id === jobId)
          : uniqueSubmissions?.[0];
        setJobs(uniqueSubmissions);
        setSelectedJob(job);
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [candidateViewData, params, updateSelectedJob]);

  const noSubmission: boolean = jobs.length === 0;

  return (
    <Resizable
      leftPanel={
        noSubmission ? (
          <Grid
            container
            rowSpacing={1}
            px={2}
            py={2.2}
            sx={{
              backgroundColor: WsColors.White,
            }}
          >
            <Grid item xs={12}>
              <Divider sx={{ mb: 1 }} />
              <Grid
                sx={{
                  height: '550px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <img
                  src={NoSubmissionSVG}
                  alt="No Candidate ?"
                  height={130}
                  width={140}
                  style={{ marginLeft: '15px' }}
                />
                <Grid item sx={{ marginLeft: '20px' }} mt={2}>
                  <WsTypography variant={WsTypoVariants.SUB_TITLE} bold={true}>
                    No Submissions
                  </WsTypography>
                </Grid>
                <Grid item sx={{ marginLeft: '10px' }} mt={1}>
                  <WsTypography color={WsTypoColors.SECONDARY} variant={WsTypoVariants.SUB_TITLE}>
                    Candidate is not submitted to any Job.
                  </WsTypography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <JobList
            onSelect={onSelect}
            jobs={jobs}
            selectedJob={selectedJob?.id}
            loadMoreText="Load more submissions"
          />
        )
      }
      rightPanel={
        noSubmission ? (
          <NoPreview text={'submission'} />
        ) : (
          <>{selectedJob && <SubmissionLayout jobId={selectedJob.id} />}</>
        )
      }
      defaultSizes={[25, 75]}
      minSize="24%"
      maxSize="76%"
      isLoading={loading}
    />
  );
};

export default Submissions;
